import styled from 'styled-components';

export const PreviewMessageInputContainer = styled.div`
    position: relative;
    width: 100%;
    border: 1px solid #D9D9D9;
    padding: 8px 16px;
    border-radius: 6px;
    background-color: #FFFFFF;
`;

export const DictionaryContainer = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
`;

export const TreeItem = styled.span`
    cursor: copy;
`;